import { gql, useMutation } from '@apollo/client';
import { Num, Obj, Str } from '@livecontrol/core-utils';
import { Event } from '@livecontrol/scheduler/model';
import { useCallback } from 'react';
import type { PartialDeep } from 'type-fest';

interface TVariables {
  event: { id: string; location: string; checked_user?: number | null };
}

interface TData {
  checkInEvent:  PartialDeep<{
    id: number;
    name: string;
    checked_user: {
      id: string;
      first_name: string;
      last_name: string;
    };
  }>;
}

interface Args {
  eventId: string;
  locationId?: string;
  checkedUser?: number;
  // refetch?: (ids: number[]) => void;
}


const MUTATION = gql`
  mutation CheckInEvent($event: CheckinEventInput!) {
    checkInEvent(event: $event)  {
      name
      id
      checked_user {
        id
        first_name
        last_name
      }
    }
  }
`;

export const useCheckinEvent = (): [
  (args: Args) => Promise<void>
] => {
  const [mutation] = useMutation<TData, TVariables>(MUTATION);

  return [
    useCallback(
      async (args: Args): Promise<void> => {

        try {
          // Parse the input arguments
          const required = {
            id: Event.toId(args.eventId)?.toString(), // @fixme - API type mismatch
            location: Str.normalize(args.locationId)
          };

          if (!Obj.isHydrated(required)) {
            throw new Error('Invalid input arguments');
          }

          const variables: TVariables = {
            event: {
              ...required,
              // eslint-disable-next-line unicorn/no-null
              checked_user: Num.normalize(args.checkedUser) ?? null
            }
          };

          await mutation({
            variables,
            update: (cache, result) => {
              cache.modify({
                id: `EventDetails:${args.eventId}`,
                fields: {
                  checked_user(): unknown {
                    return result.data?.checkInEvent.checked_user;
                  }
                }
              });
            }
          });

          // Parse the server response
        } catch (error_: unknown) {

          if(error_ instanceof TypeError){
            throw error_;
          }

        }

      },
      [mutation]
    )
  ];
};

export type UseCheckinEventsHook = typeof useCheckinEvent;

